<template>
    <v-popup :modelValue="modelValue" title="Добро пожаловать!" width="600px" @update:modelValue="close">
        <div class="instruction-content">
            <!-- Progress Bar -->
            <div class="progress-container">
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: `${(currentStep / 3) * 100}%` }"></div>
                </div>
                <div class="progress-text">Шаг {{ currentStep }} из 3</div>
            </div>

            <!-- Steps -->
            <transition name="fade" mode="out-in">
                <div :key="currentStep" class="step-wrapper">
                    <div class="step-content" v-if="currentStep === 1">
                        <h3><span class="step-badge">1</span> Создайте компанию</h3>
                        <div class="video-placeholder">
                            <!-- GIF/Video will be inserted here -->
                            <span>Демонстрация: Создание компании</span>
                        </div>
                        <p>Вам нужно создать организацию чтобы начать работу.</p>
                    </div>

                    <div class="step-content" v-if="currentStep === 2">
                        <h3><span class="step-badge">2</span> Пригласите участников</h3>
                        <div class="video-placeholder">
                            <!-- GIF/Video will be inserted here -->
                            <span>Демонстрация: Приглашение участников</span>
                        </div>
                        <p>Добавьте коллег в вашу команду для совместной работы.</p>
                    </div>

                    <div class="step-content" v-if="currentStep === 3">
                        <h3><span class="step-badge">3</span> Создайте проект</h3>
                        <div class="video-placeholder">
                            <!-- GIF/Video will be inserted here -->
                            <span>Демонстрация: Создание проекта</span>
                        </div>
                        <p>Начните новый проект и отслеживайте прогресс.</p>
                    </div>
                </div>
            </transition>
        </div>
        <template #footer>
            <div class="footer-actions">
                <default-button v-if="currentStep > 1" @click="currentStep--" text="Назад" isSecondary></default-button>

                <div class="spacer"></div>

                <default-button v-if="currentStep < 3" @click="currentStep++" text="Далее"></default-button>

                <default-button v-else @click="finish" text="Начать работу"></default-button>
            </div>
        </template>
    </v-popup>
</template>

<script>
import { useInstructionStore } from '@/store/InstructionStore.js'

export default {
    name: 'InstructionPopup',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            instructionStore: useInstructionStore(),
            currentStep: 1
        }
    },
    methods: {
        close() {
            this.instructionStore.close();
        },
        finish() {
            this.instructionStore.finish();
        }
    },
    watch: {
        modelValue(val) {
            if (val) {
                this.currentStep = 1;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.instruction-content {
    min-height: 350px;
    display: flex;
    flex-direction: column;
}

.progress-container {
    margin-bottom: 24px;
    flex-shrink: 0;

    .progress-bar {
        height: 6px;
        background: #eee;
        border-radius: 3px;
        overflow: hidden;
        margin-bottom: 8px;
    }

    .progress-fill {
        height: 100%;
        background: var(--color-blue);
        transition: width 0.3s ease;
    }

    .progress-text {
        text-align: right;
        font-size: 12px;
        color: var(--color-text-light);
    }
}

.step-wrapper {
    flex: 1;
}

.step-content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    h3 {
        margin: 0;
        font-size: 20px;
        color: var(--color-text);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .step-badge {
        background: var(--color-blue);
        color: white;
        width: 32px;
        height: 32px;
        font-size: 16px;
        font-weight: bold;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        flex-shrink: 0;
    }

    p {
        margin: 0;
        font-size: 15px;
        color: var(--color-text-light);
        line-height: 1.5;
        text-align: center;
    }
}

.video-placeholder {
    width: 100%;
    height: 220px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ddd;
    color: #999;
    font-size: 14px;
    margin: 10px 0;
}

.footer-actions {
    display: flex;
    width: 100%;
    align-items: center;

    .spacer {
        flex: 1;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
